import { defineMessages, type IntlShape } from 'react-intl';
import type {
  BlockConfigBase,
  JSONSchema,
  BlocksFormData,
  Content,
  ContainedItem,
} from '@plone/types';
import {
  addCtaFieldset,
  type CtaBlockExtender,
} from '@redturtle/qubicaamf-theme/components/Blocks/extenders/cta';

export interface BowlingCenterContent extends Content {
  bowling_center_products: object[];
  lanesnr: string;
  bowling_center_region: ContainedItem[];
  parent: ContainedItem;
}

export interface BCDescriptionTitleData
  extends CtaBlockExtender,
    JSONSchema,
    BlocksFormData {
  '@type': 'bowlingcenterdescription';
  description: string;
  text?: object;
  placeholder?: string;
  properties: Content & BowlingCenterContent;
  style?: any;
  className: string;
  restricted?: boolean;
}

export const BCDescriptionSchema = ({
  data,
  intl,
}: {
  data: BCDescriptionTitleData;
  intl: IntlShape;
}): JSONSchema => {
  const schema = {
    title: intl.formatMessage(messages.title),
    fieldsets: [
      {
        id: 'default',
        title: 'Default',
        fields: ['description'],
      },
    ],
    properties: { description: { type: 'string' } },
    required: [],
  };

  addCtaFieldset({ schema, intl });
  return schema;
};

const messages = defineMessages({
  title: {
    id: 'redturtle__volto-blocks__bowlingcenterdescription_title',
    defaultMessage: 'Bowling center description',
  },
});

export interface BCDescriptionConfig
  extends Omit<BlockConfigBase, 'blockSchema'> {
  blockSchema: typeof BCDescriptionSchema;
  requiredBlocks?: number;
}
